import type { DonorInformation } from '@/types'
import type { UserStatement } from '@/types/userStatement'

/**
 * Builds a minimal issued-statement shape for PDF export when the API has no
 * statement for a tax year (e.g. £0 gap years shown in statement history).
 */
export function createPlaceholderIssuedStatement(
  period: string,
  donor: DonorInformation,
  totals: { totalDonated?: number; totalGiftAid?: number } = {}
): UserStatement {
  const endYear = parseInt(period.split('-')[1] ?? '', 10)
  const issuedYear = Number.isFinite(endYear) ? endYear : new Date().getFullYear()

  return {
    id: `stm_${period.replace('-', '')}`,
    period,
    totalDonated: totals.totalDonated ?? 0,
    totalGiftAid: totals.totalGiftAid ?? 0,
    issued: `${issuedYear}-04-10T09:00:00.000Z`,
    donor,
  }
}
